import { getLocalizedMeta } from '@/utils/common'

const Layout = () => import('@/layout/index.vue')

export default {
  name: 'Subscribe',
  path: '/:language?/subscribe',
  component: Layout,
  redirect: '/subscribe/index',
  children: [
    {
      name: 'SubscribeIndex',
      path: 'index',
      component: () => import('@/views/subscribe/index.vue'),
      meta: {
        hideTab: false,
        menu: 'Subscribe',
        ...getLocalizedMeta('plan')
      }
    },
    {
      name: 'TranscriptionLanguages',
      path: 'transcription-languages',
      component: () => import('@/views/subscribe/pages/TranscriptionLanguages/Index.vue'),
      meta: {
        hideTab: false,
        menu: 'Subscribe',
        ...getLocalizedMeta('transcriptionLanguages')
      }
    }
  ]
}
